export enum ViewMode {
    List = 'list',
    Grid = 'grid',
    Graph = 'graph'
}